import React, {FC} from 'react';
import {observer} from 'mobx-react-lite';
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import sass from '../role-description-popover/role-description-popover.module.sass';

export const IamRolesPopOver: FC = observer(() => {

    const popover = (
        <Popover id="roleDescription">
            <Popover.Header as="h3">Project User Permissions</Popover.Header>
            <Popover.Body>
                <div><strong>User Admin</strong></div>
                <div className="mb-2"><small>User admins can create/edit/delete users and user permissions for this
                    project.</small></div>
                <div><strong>User Viewer</strong></div>
                <div className="mb-2"><small>User viewers can view users and their permissions for this
                    project.</small></div>
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger="click"
            placement="right"
            overlay={popover}
            rootClose={true}>
            <span className={sass.info}><i className={`fa fa-info-circle`}/></span>
        </OverlayTrigger>
    );
});

